"use client";

import { ServiceSnapshotGrid } from "@/components/ui/service-snapshot-grid";
import { getSiteConfig } from "@/lib/config";
import { Section } from "@/components/layout/Section";
import { Container } from "@/components/ui/container";

interface ExploreOtherServicesProps {
    currentSlug: string;
}

export function ExploreOtherServices({ currentSlug }: ExploreOtherServicesProps) {
    const config = getSiteConfig();

    // Filter out the current service and disabled services
    const otherServices = config.services
        .filter((s) => s.slug !== currentSlug && s.enabled)
        .map(s => ({
            ...s,
            description: "" // Hide descriptions in "Other Services"
        }));

    if (otherServices.length === 0) return null;

    return (
        <Section className="bg-gray-50/50">
            <Container>
                <div className="space-y-12">
                    <div className="text-center space-y-4">
                        <h2 className="text-3xl font-bold text-[#391d5a]">Explore Other Services</h2>
                        <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                            Comprehensive telecom solutions tailored to your business needs
                        </p>
                    </div>
                    <ServiceSnapshotGrid items={otherServices} className="lg:grid-cols-3" centerTitle />
                </div>
            </Container>
        </Section>
    );
}
